import { memo } from "react";

import { WEIGHT_BOLD } from "@hl/base-components/lib/theme/typography";
import { Button, Divider, Modal, Stack, Text, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";

type AddMetadataTraitsModalData = {
  isOpen: boolean;
  onClose: () => void;
  handleSubmit: (values: CollectionAttributeFormValues) => void;
};

export interface CollectionAttributeFormValues {
  name: string;
  value: string;
}

const AddMetadataTraitsModal = ({
  isOpen,
  onClose,
  handleSubmit,
}: AddMetadataTraitsModalData) => {
  const form = useForm<CollectionAttributeFormValues>({
    initialValues: {
      name: "",
      value: "",
    },
    validate: (values) => {
      return {
        name: !values.name.trim() ? "Name is required" : null,
        value: !values.value.trim() ? "Value is required" : null,
      };
    },
  });

  return (
    <Modal
      centered
      size={"lg"}
      opened={isOpen}
      onClose={onClose}
      title={
        <Text size="lg" fw={WEIGHT_BOLD}>
          Add a trait
        </Text>
      }
    >
      <form
        onSubmit={form.onSubmit((values) => {
          handleSubmit(values);
          onClose();
          form.reset();
        })}
      >
        <Stack>
          <Stack spacing={24}>
            <TextInput
              label="Trait name"
              placeholder="Background color"
              {...form.getInputProps("name")}
            />
            <TextInput
              label="Trait value"
              placeholder="Green"
              {...form.getInputProps("value")}
            />
          </Stack>
          <Divider mx={-16} />
          <Button
            type="submit"
            size="xl"
            disabled={!form.isTouched() || !form.isValid()}
          >
            Add attribute
          </Button>
        </Stack>
      </form>
    </Modal>
  );
};

export default memo(AddMetadataTraitsModal);
